<style lang="scss">
  .card{
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
  }
  .vtable{
    min-height: 75vh !important;
  }
</style>
<template lang="pug">
  .row
    .table-vue(  style="width: 1100px" )
      vue-table-dynamic( :params="params" @select="onSelect" @selection-change="onSelectionChange" ref="table") 
</template>
<script>
import VueTableDynamic from 'vue-table-dynamic'
import M from 'materialize-css'
import firebase from '../config'
const { db } = firebase;

export default {
  name: "TableUsers",
  props:{
    datosUser:{ type:Object , default: () => { return {}} },
    itemsDisponibles:{ type:Array , default: () => { return []} },
    params: {  default: () => { return { 
        data: [ ["Nombre", "Rol","Correo"] ] ,
        header: 'row',
        border: true,
        stripe: true,
        enableSearch: true,
        sort: [0, 1],
        pagination: true,
        pageSize: 20,
        height: 180,
        showCheck: true,
        maxWidth:700,
        height:500
      }
    },  type: Object }
  },
  components: {
    VueTableDynamic,
  },
  data() {
    return {

      }
  },
  firestore: {
    // itemsDisponibles: db.collection('todos'),
  },
  methods: {
    openModal(){
      let elems = document.querySelector("#modal1");
      let modal = M.Modal.init(elems, {});
      modal.open();
    },
    getSendData() {
      return this.dataChecked;
    },
    onSelectionChange (isChecked, index, data){
      console.log("aaaaahh");
    },
    onSelect (isChecked, index, data) {
      // console.log('onSelect: ', isChecked, index, data)
      let _x = this.$refs.table.getCheckedRowDatas(true);
      this.$emit('sendDataForm', this.itemsDisponibles[index-1]);
      setTimeout(() => {
        // setAllRowChecked:function
        this.$refs.table.setAllRowChecked(false);
      }, 2 );

      
    },
    gatData() {
      this.params = {
        // pageSizes: [5, 10, 20, 50]
      }
    }
  },
		created () {
 
		}
}
</script>